// product-gallery.js
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.k-gallery')) return;

  function initGallery() {
    // wait until Swiper lib loaded
    if (typeof Swiper === 'undefined') {
      // try again shortly
      setTimeout(initGallery, 200);
      return;
    }

    var thumbSelector = '.k-thumb-swiper';
    var mainSelector = '.k-main-swiper';

    var thumbEl = document.querySelector(thumbSelector);
    var mainEl = document.querySelector(mainSelector);

    if (!thumbEl || !mainEl) return;

    var thumbSwiper = new Swiper(thumbSelector, {
      direction: 'vertical',
      slidesPerView: 2,
      spaceBetween: 10,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      breakpoints: {
        0: { direction: 'horizontal', slidesPerView: 4 },
        769: { direction: 'vertical', slidesPerView: 2 }
      }
    });

    var mainSwiper = new Swiper(mainSelector, {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: {
        swiper: thumbSwiper
      }
    });

    // clicking fallback
    document.querySelectorAll('.k-thumb-swiper .swiper-slide').forEach(function (el, idx) {
      el.addEventListener('click', function () {
        mainSwiper.slideTo(idx);
      });
    });
  }

  initGallery();
});
